export const wrapper = 'bg-white h-full pt-2 pb-4 px-4';
export const checkboxWrapper =
  'flex w-full flex-row justify-start items-center';
